import { StateObservable } from 'redux-observable';
import { catchError } from 'rxjs/operators';
import { localStoreEpic } from '@support/localStore';
import appEpics from '@repo/redux/epics';
import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';
import { ReduxAction } from '@repo/utils/types';
import AppState from '@repo/redux/app-state';

const rootEpic = (
  action$: Observable<ReduxAction>,
  store$: StateObservable<AppState>,
  dependencies: any,
) =>
  combineEpics(localStoreEpic, ...Object.values(appEpics))(action$, store$, dependencies).pipe(
    // catchall error handling
    catchError((error, source) => {
      console.error(error);
      return source;
    }),
  );

export default rootEpic;
